//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { 
  Alert,
  Button, 
  Modal,
  Snackbar
} from '@mui/material';
import {
  Description as DescriptionIcon,
  Info as InfoIcon,
  Close
} from '@mui/icons-material';
import React, { useEffect, useMemo, useState } from 'react';
import { DueTodayIcon, PastDueTodayIcon } from "utils/assets/images";
import Loading from "components/Loading";
import { filter, find, get, map } from "lodash";
import moment from 'moment';
import { Img } from 'react-image';
import { useNavigate } from "react-router-dom";
import { useAllBook , useUserAllowedBooks } from 'store/books/selectors';
import { useBookUnits } from "store/booksUnits/selectors";
import { useClassActivities } from 'store/classActivities/selectors';
import { useClassQuizzes } from 'store/classQuizzes/selectors';
import { useExams } from 'store/exams/selectors';
import { useCurrentOrgPermission } from 'store/organizations/selectors';
import { useResources, useVideos } from 'store/resources/selectors';
import AssignmentReviewByTeacher from "components/AssignmentReviewByTeacher";
import { useCurrentClass, useCurrentClassBook } from 'store/classes/selectors';
import { useUserClasses } from 'store/userClasses/selectors';
import { useCurrentUser } from 'store/users/selectors';
import styled from 'styled-components';
import { useClassSubmissions } from 'store/submissions/selectors'
import { getBookDisplayName, getUserAssignment, imageFetch, imageFetchFromPodcast, isVideo, getStoryUrl, generateUrlForNonEbook, getEbookAssignmentDeepLinkUrl, getExceptionStatus, getAssignmentNavigationUrl } from "utils/lib/ebookHelper";
import { useStory } from "store/story/selectors";
import { BACK_TO_BOOK } from 'utils/config/reference';
import { Menu, Popover } from 'antd';
import PopoverContent from 'components/UI/PopoverConf/Popover';
import { useUserPreference } from 'store/userPreference/selectors';
import { useAssignmentCoverTitle } from 'components/hooks/pageCover/useAssignmentCoverTitle';
import { handleCreateUserPreference, handleGetStudentUserPreference, handleUpdateUserPreference, handleGetUserPreference } from 'store/userPreference/thunks';
import { useDispatch } from 'react-redux';
import { isDisabledForMe } from 'utils/methods/validateData';
import { useClassGameActivity } from 'store/one_game/selectors';
import { useAlert } from './UI/alertSakeBar/alertProvider';
import { getCoverForAssignment } from 'utils/methods/functions';
import useActiveStudentofParent from './hooks/parent/activeStudentofParent';
import startSvg from "../utils/assets/images/start.svg";
import dueSvg from "../utils/assets/images/due.svg";
import missingSvg from "../utils/assets/images/missing.svg";
import { usePageCover } from './hooks/pageCover/pageCover';
import useNotification from './hooks/notification/useNotification';
import SentryWrap from 'components/Sentry';
moment.updateLocale('en', {
    week: {
        dow: 1,
    },
})
const ORDER_BY = [
    { key: "due_date", value: "Due Date" },
    { key: "start_date", value: "Start Date" },
    { key: "late_submission", value: "Late Date" },
]

const Wrapper = styled.div`
    filter: drop-shadow(0px 0px 2.54px rgba(0, 0, 0, 0.26));
    background: #fff;
    border-radius: 0px 0px 18px 18px;
    height: 100%;
    margin-bottom: 100px;
    padding: 24px 20px;
    @media (max-width: 1199px) {
     margin-bottom: 40px;
    }
`;

const SectionHeader = styled.p`
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 12px;
    text-transform: uppercase;
    font-family: Arial;
    @media (max-width: 530px) {
      font-size: 10px;
      margin-bottom: 6px;
   }
`;
const Section = styled.div` `;
const AssignmentArea = styled.div`
    min-height: 114px;
    padding: 18px 18px;
    border-radius: 16px;
    background: #F4F5FA;
`;
const AssignmentDac = styled.div`
    background: #ffffff;
    padding: 8px 10px;
    border-radius: 8px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: ${p => p.past ? 'not-allowed' : 'pointer'};
`;
const AssignmentText = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: ${p => p.past ? 'not-allowed' : 'pointer'};
    color:black;
    width:100%;
    min-height:30px !important;
    max-width: ${p => p?.role === "teacher" ? "72%" :"85%"  }
`;
const AssignmentLabel = styled.label`
    cursor: ${p => p.past ? 'not-allowed' : 'pointer'};
    display: block;
    // width: 100px;
    overflow: hidden;
    white-space: nowrap;
    // text-overflow: ellipsis;
`;
const AssignmentTrack = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
`;
const TrackIcon = styled.img`
    height:100px;
    @media (max-width: 530px) {
      height: 73px;
    }
`;
const TrackLabel = styled.label`
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    font-family: Arial;

    @media (max-width: 530px) {
       font-size: 12px;
    }
`;
const ImageModal = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90vw;
    height: 90vh;
    margin-top:20px;
`;

const CloseBtn = styled.div`
    background-color: rgb(204, 80, 71);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    right: 10px;
    color: white;
    z-index: 2;
    position:absolute;
    top:-45px;
    right:-13px;
`;
const ModelDescRow = styled.div`
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 10px;
    position:absolute;
    background:#E7E8EA;
    width:100%;
    display:flex;
    align-items:center;
    justify-content:center;
    height:35px;
    border-bottom:.5px solid lightgray;
    margin-top:-35px;
`;
const StyledImg = styled(Img)`
  width: ${({ imgType }) => (imgType ? "70vw" : "100%")};
  height: 100%;
  max-width: 90vw;
  max-height: 80vh;
  object-fit: contain;

  @media (min-width: 1367px) {
    width: ${({ imgType }) => (imgType ? "34vw" : "100%")};
  }

  @media (max-width: 600px) {
    max-height: 70vh;
  }
`;
const ItemTab2 = styled.button`
    height:100%;
    width:10%;
    background: none;
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    padding:8px;
    cursor: pointer;
`;
const IconCol = styled.div`
   display: flex;
   flex-direction: row;
   width: 50px;
`;

const PaddedBtn = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px;
    text-align: left;
    width: 100%;
`;

export default function AssignmentLists({ headerChild }) {
    const exams = useExams();
    const classActivities = useClassActivities()
    const {  class_game_activity } = useClassGameActivity()
    const worksheet_activity = useMemo(()=>Array.isArray(class_game_activity)?class_game_activity.filter(k=>k.type=='worksheet'):[],[class_game_activity])
    const currentUser = useCurrentUser()
    const classQuizzes = useClassQuizzes()
    const booksAllList = useAllBook()
    const story = useStory()
    const orgPermissions = useCurrentOrgPermission()
    const resources = useResources()
    const videos = useVideos()
    const currentClass = useCurrentClass()
    const userClasses = useUserClasses();
    const dispatch = useDispatch();
    const [dueToday, setDueToday] = useState([])
    const [startToday, setStartToday] = useState([])
    const [upcommingThisWeek, setUpcommingThisWeek] = useState([])
    const [pastDueThisWeek, setPastDueThisWeek] = useState([])
    const [modalOpen, setModalState] = useState(false);
    const [activeAssignment, setActiveAssignment] = useState(null)
    const [datePrefrences, setDatePrefrences] = useState('due_date');
    const [updateDateLoader, setUpdateDateLoader] = useState(false);
    const [openPop, setOpen] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    const [dueDatePref, setDueDatePref] = useState({})
    const [popoverOpen, setPopoverOpen] = useState(null);
    const bookUnits = useBookUnits()
    const navigate = useNavigate();
    const submissions = useClassSubmissions();
    const userPreference = useUserPreference();
    const showAlert = useAlert();
    const userAllowedBooks = useUserAllowedBooks()
    const allowed_books = useCurrentClassBook();
    const { activeStudentParent } = useActiveStudentofParent();
    const pageCover = usePageCover({ assignmentData: activeAssignment?.data });
    const { readSingleNotification } = useNotification();

    const isExamHidden = (chapter) => {
        const fetchExams = exams?.find((entry) => entry.exams.flatMap((exam) => `${exam.bookId}`).includes(`${chapter}`));
        if (!fetchExams) {
            return false;
        }
        const classInfo = find(userClasses, ['id', currentClass?.id]);
        const isHidden = classInfo?.config?.meta_data || {};
        const examLevel = fetchExams?.exam_school || '';
        if (isHidden.highSchool && examLevel === 'high') {
            return true;
        }
        if (isHidden.middleSchool && examLevel === 'middle') {
            return true;
        }
        return false;
    };

    const filterWeekAssignment = (assignment) => {
        if (!assignment) return false;
        const _dueDate = get(assignment, "dueDate")
        return moment(_dueDate).isSame(moment(), "week")
    }

    const filterStartWeekAssignment = (assignment) => {
        if (!assignment) return false;
        const _dueDate = get(assignment, "scheduleAt")
        return moment(_dueDate).isSame(moment(), "week")
    }

    const filterWeekAssignmentUpcoming = (assignment) => {
        if (!assignment) return false;
        const getUserPref = userPreference;
        const _dueDate = get(assignment, getUserPref?.order_by_date === 'start_date' ? "scheduleAt" : getUserPref?.order_by_date === 'late_submission' ? "lateDate" : "dueDate") || (getUserPref?.order_by_date === 'late_submission' && get(assignment, "dueDate"))
        return moment(_dueDate).isSame(moment(), "week")
    }

    const filterWeekAssignmentPast = (assignment) => {
        if (!assignment) return false;
        const _dueDate = get(assignment, "lateDate")
        return moment(_dueDate).isSame(moment(), "week")
    }

    const filterDueDateUpcomming = (weekAssignmentUpcomming) => {
        let filterDate = [];
        if (userPreference?.order_by_date === 'start_date') {
            filterDate = filter(weekAssignmentUpcomming, a => moment(a.scheduleAt).isSame(moment(), "day") && moment(a.scheduleAt).isAfter(moment(), "minute"))
        } else if (userPreference?.order_by_date === 'late_submission') {
            filterDate = filter(weekAssignmentUpcomming, a => {
                const dateToCheck = a.lateDate || a.dueDate;
                return !moment(dateToCheck).isSame(moment(), "day") && moment(dateToCheck).isAfter(moment(), "minute");
            })
        } else {
            filterDate = filter(weekAssignmentUpcomming, a => !moment(a.dueDate).isSame(moment(), "day") && moment(a.dueDate).isAfter(moment(), "minute"))
        }
        return filterDate;
    }

    const modalSrc = () => {
        if(pageCover){
            return pageCover;
        }
        const cover_img = getCoverForAssignment(activeAssignment)
        if (cover_img) return cover_img;
        const chapter = get(activeAssignment, "data.chapter", "") ||  get(activeAssignment, "assignment.chapter", "")
        const assignmentPage = get(activeAssignment, "data.page", 0) || get(activeAssignment, "assignment.page", 0)
        return isVideo(chapter, resources) ? imageFetchFromPodcast(chapter, resources) : imageFetch(booksAllList, chapter, assignmentPage)
    }

    const getStudentSubmission = (weekAssignmentPast, type) => {
        const filteredData = weekAssignmentPast
            .filter(answer => {
                const assignment = submissions.find(item => item.assignmentId === answer.data?.id || item.assignmentId == answer?.activityId ||
                    (answer?.type === 'worksheet' && (item.assignmentId === answer?.session_id || item.assignmentId === answer?.game_id))
                );
                const diff = get(assignment, "diff[0]");
                let retakeAvailable = false;
    
                if (diff) {
                    retakeAvailable = assignment ? parseInt(get(assignment, "submissions", 0), 10) < (parseInt(get(diff, "retakes"), 10) + 1) : true;
                } else {
                    retakeAvailable = assignment ? parseInt(get(assignment, "submissions", 0), 10) < (parseInt(get(answer, "retakes"), 10) + 1) : true;
                }
                const completed = !retakeAvailable && get(assignment, "complete", false);
                const retake = retakeAvailable && !completed;
                return retake || answer?.type === 'worksheet';
            })
            
        const getMissingFilter = filter(filteredData, a => a.lateDate && moment(a.dueDate).isBefore(moment(), "minute") && moment(a.lateDate).isAfter(moment(), "minute"));
        const getDueFilter = filter(filteredData, a => moment(a.dueDate).isSame(moment(), "day") && moment(a.dueDate).isAfter(moment(), "minute") && !moment(a.scheduleAt).isSame(moment(), "day"))
        const getStartFilter = filter(filteredData, a => {
            const is_same_day = moment(a.scheduleAt).isSame(moment(), "day");
            const is_start_beforemoment = moment(a.scheduleAt).isBefore(moment(), "seconds");
            const is_due_after_moment = moment(a.dueDate).isAfter(moment(), "seconds");
            return is_same_day && is_start_beforemoment && is_due_after_moment;
        })
        if (type === 'missing') {
            return getMissingFilter;
        } else if (type === 'due'){
            return getDueFilter;
        } else {
            return getStartFilter;
        }
    };

    useEffect(() => {
        if (get(currentUser, "role") == 'student') {
            const allAssignment = [...classActivities, ...classQuizzes , ...worksheet_activity]
            const userAssignment = getUserAssignment(allowed_books, allAssignment, currentUser, currentClass,userAllowedBooks?.other_permissions?.resourses,activeStudentParent)
            const weekAssignment = filter(userAssignment, filterWeekAssignment)
            const weekStartAssignment = filter(userAssignment, filterStartWeekAssignment)
            const weekAssignmentUpcomming = filter(userAssignment, filterWeekAssignmentUpcoming)
            const weekAssignmentPast = filter(userAssignment, filterWeekAssignmentPast)
            // const todayAssignment = filter(weekAssignment, a => moment(a.dueDate).isSame(moment(), "day") && moment(a.dueDate).isAfter(moment(), "minute") && !moment(a.scheduleAt).isSame(moment(), "day"))
            const todayAssignment = getStudentSubmission(weekAssignment, 'due');
            // const todayStartAssignment = filter(weekStartAssignment, a => moment(a.scheduleAt).isSame(moment(), "day") && moment(a.scheduleAt).isBefore(moment(), "minute") && moment(a.dueDate).isAfter(moment(), "minute"))
            const todayStartAssignment = getStudentSubmission(weekStartAssignment, 'start');
            const pastThisWeek = getStudentSubmission(weekAssignmentPast, 'missing');
            const upcommingWeek = filter(weekAssignmentUpcomming, a => !moment(userPreference?.order_by_date === 'start_date' ? a.scheduleAt : userPreference?.order_by_date === 'late_submission' ? a.lateDate || a.dueDate : a.dueDate).isSame(moment(), "day") && moment(userPreference?.order_by_date === 'start_date' ? a.scheduleAt : userPreference?.order_by_date === 'late_submission' ? a.lateDate || a.dueDate : a.dueDate).isAfter(moment(), "minute"))
            setDueToday(todayAssignment)
            setStartToday(todayStartAssignment)
            setUpcommingThisWeek(upcommingWeek)
            setPastDueThisWeek(pastThisWeek)
        }
    }, [classActivities, classQuizzes, currentUser, booksAllList, orgPermissions, currentClass, userPreference, worksheet_activity, allowed_books, activeStudentParent, submissions])
    useEffect(() => {
        if (get(currentUser, "role") != 'student') {
            const allAssignment = [...classActivities, ...classQuizzes ,...worksheet_activity]
            const weekAssignment = filter(allAssignment, filterWeekAssignment)
            const weekStartAssignment = filter(allAssignment, filterStartWeekAssignment)
            const weekAssignmentUpcomming = filter(allAssignment, filterWeekAssignmentUpcoming)
            const weekAssignmentPast = filter(allAssignment, filterWeekAssignmentPast)
            const todayAssignment = filter(weekAssignment, a => moment(a.dueDate).isSame(moment(), "day") && moment(a.dueDate).isAfter(moment(), "minute") && !moment(a.scheduleAt).isSame(moment(), "day"))
            const todayStartAssignment = filter(weekStartAssignment, a => moment(a.scheduleAt).isSame(moment(), "day") && moment(a.dueDate).isAfter(moment(), "minute"))
            const pastThisWeek = filter(weekAssignmentPast, a => (a.lateDate && moment(a.dueDate).isBefore(moment(), "minute")) ? moment(a.lateDate).isAfter(moment(), "minute") : null)
            const upcommingWeek = filterDueDateUpcomming(weekAssignmentUpcomming);
            setDueToday(todayAssignment)
            setStartToday(todayStartAssignment)
            setUpcommingThisWeek(upcommingWeek)
            setPastDueThisWeek(pastThisWeek)
        }
    }, [classActivities, classQuizzes, currentUser, orgPermissions, userPreference , worksheet_activity])

    useEffect(() => {
        if (userPreference && typeof userPreference?.order_by_date === "string") {
            if (userPreference?.order_by_date === "start_date" || userPreference?.order_by_date === 'due_date' || userPreference?.order_by_date === 'late_submission') {
                setDatePrefrences(userPreference?.order_by_date)
            }
        } else if (!userPreference || !userPreference?.order_by_date) {
            setDatePrefrences('due_date')
        }
    }, [userPreference])

    useEffect(() => {
        if (currentUser && currentUser.id) {
            dispatch(handleGetUserPreference(currentUser.id));
        }
    }, [currentUser, dispatch])

    useEffect(() => {
        if (get(currentUser, "role") === 'student') {
            getTeacherPref();
        }
    }, [currentClass, currentUser])
    
    const getTeacherPref = async () => {
      if (!userPreference || !userPreference.order_by_date) {
        await dispatch(handleGetStudentUserPreference(currentClass?.teacherId, currentClass?.id));
        // setDueDatePref(getDuePref)
      }
    }

    const viewInfo = (x) => {
        setActiveAssignment(x)
        setModalState(true)
    }
    const redirectToAssignmentVideo = (id, data) => {
        const url = `/video?id=${id}&quiz=null`
        const urlPath = getAssignmentNavigationUrl(url, data);
        navigate(urlPath);
    }
    const generateUrl = (CHAPTER_ID, page, activity, quiz) => {
        const storyUrl = getStoryUrl(story, CHAPTER_ID, page, quiz, activity)
        const backToLabel = BACK_TO_BOOK[CHAPTER_ID]
        const BALCON_PAGES = get(find(bookUnits, ["bookId", CHAPTER_ID]), "pages", [])
        const bookitem = find(BALCON_PAGES, k => parseInt(k.start) <= page && parseInt(k.finish) >= page)
        const url = generateUrlForNonEbook(bookitem?.id, page, activity, quiz, backToLabel, null, CHAPTER_ID)
        if (url && backToLabel) {
            return url;
        }
        else if (storyUrl) {
            return storyUrl;
        } else {
            return null;
        }
    }
    const redirectToBook = (data) => {
      const chapter = get(data, 'data.chapter', '') || get(data, 'assignment.chapter', '');
      const assignmentPage = get(data, 'data.page', 0) || get(data, 'assignment.page', 0);
      if (get(currentUser, "role") === "student" && isExamHidden(chapter)) {
        showAlert('Your teacher has hidden this exam and you are no longer able to take it.', 'info');
        return;
      }
      readSingleNotification(chapter,assignmentPage,currentUser,data);
      const generatedUrl = generateUrl(chapter, assignmentPage, null, null);
      if (data?.assignfrom && data?.assignfrom?.urlPath) {
        navigate(data?.assignfrom?.urlPath);
        return;
      }
      if (isVideo(chapter, resources)) {
        redirectToAssignmentVideo(chapter, data);
      } else if (generatedUrl) {
        navigate(getAssignmentNavigationUrl(generatedUrl, data));
      } else {
        navigate(`/ebook?chapter=${chapter}&page=${assignmentPage}&activity=null&quiz=null`);
      }
    };

    const getAssignmentStatus = (retakeAvailable, submission, isActive, deactivateForStudent) => {
        const completed = !retakeAvailable && get(submission, "complete", false)
        const retake = retakeAvailable && get(submission, "complete", false)
        const { isException, exceptionStatusText } = getExceptionStatus(submission, currentUser)

        if(isException){
            return `(${exceptionStatusText})`
        }
         else if (completed) {
            return ` (Completed) `
        } else if (!isActive || deactivateForStudent) {
            return ` (Deactivated) `
        } else if (retake) {
            return ` (Retake) `
        }else if (submission) {
            return ` (Resume) `
        }else {
            return '  (Due)'
        }
    }
    const info = () => {
        showAlert('This activity is currently inactive!', "warning");
    };
    const renderStudentAssignment = (x) => {
        const getHiddenBooks = get(currentClass,"hide_books",[]).map(data => data?.bookId) || [];
        if(get(currentUser, "role") === "student" &&  getHiddenBooks?.includes(x?.data?.chapter)){
            return null;
        }
        const submission = find(submissions, k =>
            k.assignmentId == x.data?.id ||
            k.assignmentId == x.activityId ||
            (x.type === 'worksheet' && (k.assignmentId == x.session_id || k.assignmentId == x.game_id))
        );
        const retakeAvailable  = submission ? parseInt(get(submission, "submissions", 0), 10) < (parseInt(get(x, "retakes"), 10) + 1) : true;
        const completed = !retakeAvailable && get(submission, "complete", false)
        const displayName = get(x, 'displayName', get(x, 'data.displayName', ''));
        const isActive = get(x, "active", true);
        const deactivateForStudent = isDisabledForMe(x,currentUser?.id);
        return (
            <Popover content={<PopoverContent booksAllList={booksAllList} x={x} currentUser={currentUser} currentClass={currentClass} />} title="Assignment Info" trigger="hover">
                <AssignmentDac className="assignDateInr" key={x.id}>
                    <AssignmentText role={get(currentUser, "role")} className="assignDateLft assignDateLftCstm" onClick={() => {
                        if (!isActive || deactivateForStudent) {
                            info();
                            return;
                        }
                        redirectToBook(x)
                    }}>
                        <DescriptionIcon />
                        <AssignmentLabel>
                            {/* {getAssignmentLable(x, booksAllList, videos, resources)} */}
                            {displayName?.length > 20 ? `${displayName.slice(0, 20)}...` : displayName}
                        </AssignmentLabel>
                        {getAssignmentStatus(retakeAvailable, submission, isActive, deactivateForStudent)}
                    </AssignmentText>
                    <ItemTab2 onClick={() => viewInfo(x)}>
                        <InfoIcon className="assignDateRght" />
                    </ItemTab2>
                </AssignmentDac>
            </Popover>
        )
    }
    const renderTeacherAssignment = (x) => {
        const displayName = get(x, 'displayName', get(x, 'data.displayName', ''));
        const isActive = get(x, "active", true)
        return (
            <Popover
                content={<PopoverContent booksAllList={booksAllList} x={x} currentUser={currentUser} currentClass={currentClass} />}
                title="Assignment Info"
                trigger="hover"
                open={popoverOpen === x.id}
                onOpenChange={(visible) => visible ? setPopoverOpen(x.id) : setPopoverOpen(null)}
            >
                <AssignmentDac className="assignDateInr" key={x.id}>
                    <AssignmentText role={get(currentUser, "role")}  className="assignDateLft assignDateLftCstm">
                        <AssignmentReviewByTeacher assignment={x} onReviewClick={() => setPopoverOpen(null)} />
                        <AssignmentLabel>
                            {/* {getAssignmentLable(x, booksAllList, videos, resources)} */}
                            {displayName?.length > 20 ? `${displayName.slice(0, 20)}...` : displayName}
                            </AssignmentLabel>
                            {!isActive ? "  (Deactivated)" : null}
                    </AssignmentText>
                    <IconCol>
                        <ItemTab2 onClick={() => redirectToBook(x)}>
                            <DescriptionIcon />
                        </ItemTab2>
                        <ItemTab2 onClick={() => viewInfo(x)} style={{ marginLeft: 10, marginTop: 3 }}>
                            <InfoIcon className="assignDateRght" />
                        </ItemTab2>
                    </IconCol>

                </AssignmentDac>
            </Popover>
        )
    }
    const closeViewinfo = () => {
        setModalState(false)
        setActiveAssignment(null)
    }

    const getHiddenBooks = get(currentClass, "hide_books", []).map(data => data?.bookId) || [];

    const pastCheckOnDisable = useMemo(() => {
      if (get(currentUser, "role") === "student") {
        const data = pastDueThisWeek
          ?.map((x) => {
            if (getHiddenBooks?.includes(x?.data?.chapter)) {
              return x;
            } else {
              return;
            }
          })
          .filter((x) => x !== undefined);

            if (data?.length === 0) {
                return false;
            } else {
                return true;
            }
        }
        return false;
    }, [pastDueThisWeek, getHiddenBooks]);


    // const upComingcheckOnDisable = useMemo(() => {
    //     if (get(currentUser, "role") === "student") {
    //         const data = upcommingThisWeek
    //             ?.map((x) => {
    //                 if (getHiddenBooks?.includes(x?.data?.bookId)) {
    //                     return x;
    //                 } else {
    //                     return;
    //                 }
    //             })
    //             .filter((x) => x !== undefined);

    //         if (data?.length === 0) {
    //             return false;
    //         } else {
    //             return true;
    //         }
    //     }
    //     return false;
    // }, [upcommingThisWeek, getHiddenBooks]);

    const dueCheckOnDisable = useMemo(() => {
        if (get(currentUser, "role") === "student") {
            const data = dueToday
                ?.map((x) => {
                    if (getHiddenBooks?.includes(x?.data?.bookId)) {
                        return x;
                    } else {
                        return;
                    }
                })
                .filter((x) => x !== undefined);

            if (data?.length === 0) {
                return false;
            } else {
                return true;
            }
        }
        return false;
    }, [dueToday, getHiddenBooks]);

    const startCheckOnDisable = useMemo(() => {
        if (get(currentUser, "role") === "student") {
            const data = startToday
                ?.map((x) => {
                    if (getHiddenBooks?.includes(x?.data?.bookId)) {
                        return x;
                    } else {
                        return;
                    }
                })
                .filter((x) => x !== undefined);

            if (data?.length === 0) {
                return false;
            } else {
                return true;
            }
        }
        return false;
    }, [startToday, getHiddenBooks]);

    const onDateChange = async (order_by_date) => {
        setUpdateDateLoader(true)
        if (currentUser) {
            if (!userPreference || typeof userPreference == "object" && Object.keys(userPreference).length == 0) {
                await dispatch(handleCreateUserPreference(currentUser.id, { order_by_date }))
            } else {
                await dispatch(handleUpdateUserPreference(currentUser.id, { order_by_date }))
            }
            setOpen(true);
            setPopupMessage(`This change will be automatically updated to all the classes`)
        }
        setUpdateDateLoader(false)
    }

    const orderNav = () => {
        return (
            <Menu>
                {ORDER_BY.map((item) => (<Menu.Item key={item.key} style={{ padding: '0px' }}>

                    <PaddedBtn onClick={() => {
                        setDatePrefrences(item.key)
                        onDateChange(item.key)
                    }}>
                        {item.value}
                    </PaddedBtn>

                </Menu.Item>))}
            </Menu>
        );
    }

    const handleClose = () => {
        setOpen(false);
    };
    const displayName =  get(activeAssignment, 'displayName', get(activeAssignment, 'data.displayName', ''));
    const coverTitle = useAssignmentCoverTitle({ assignment: activeAssignment, title: displayName });
    return (
        <SentryWrap>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={openPop}
                autoHideDuration={5000}
                onClose={handleClose}>
                <Alert onClose={handleClose} severity="info">
                    <strong>ALERT:</strong> {popupMessage}
                </Alert>
            </Snackbar>
            <Modal open={modalOpen} onClose={closeViewinfo} className="444 imgModl">
                <ImageModal>
                    <div className="mdlcont">
                        <CloseBtn onClick={closeViewinfo}>
                            <Close className="closeIcns" />
                        </CloseBtn>
                        <ModelDescRow>
                            {getBookDisplayName(booksAllList,  get(activeAssignment, "data.chapter", "") ||  get(activeAssignment, "assignment.chapter", ""), true, videos, resources)}
                        </ModelDescRow>
                        <StyledImg imgType={isVideo(get(activeAssignment, "data.chapter"), resources)} src={modalSrc()} loader={<Loading />} />
                         {coverTitle ? <label className='storyTitleCstm'>{coverTitle}</label> : null}
                    </div>
                </ImageModal>
            </Modal>

            <div style={{ marginTop: '20px' }}>
              <div className='myAssignmentSec'>
               <Button>my assignments {headerChild}</Button>
              </div>

            <Wrapper className='assignSectionUpr'>
                
                <div className='assignSection startTodayCstm'>
                  <SectionHeader className='startTodayLabel'>Start today</SectionHeader>
                  <Section>
                    {(startToday.length === 0 || startCheckOnDisable) ? (
                        <AssignmentArea className='assignSectionInr'>
                        <AssignmentTrack className='assignSectionInrSub'>
                            <TrackLabel className='assignSectionInrSubLeft'>
                            No assignments at this moment.
                            </TrackLabel>
                            <img
                            src={startSvg}
                            alt=""
                            title=""
                            />
                        </AssignmentTrack>
                        </AssignmentArea>
                    ) : (
                        <AssignmentArea className='assignSectionInr assignSectionData'>
                        {map(startToday, d =>
                            currentUser.role === "teacher"
                            ? renderTeacherAssignment(d)
                            : renderStudentAssignment(d)
                        )}
                        </AssignmentArea>
                    )}
                  </Section>
                </div>

                <div className='assignSection'>
                  <SectionHeader className='dueTodayLabel'>Due today <span className='assignLastDay'>(last day to submit assignments)</span></SectionHeader>
                  <Section>
                    {(dueToday.length === 0 || dueCheckOnDisable) ? (
                        <AssignmentArea className='assignSectionInr'>
                        <AssignmentTrack className='assignSectionInrSub'>
                            <TrackLabel className='assignSectionInrSubLeft'>
                            No assignments at this moment.
                            </TrackLabel>
                            <img
                            src={dueSvg}
                            alt=""
                            title=""
                            />
                        </AssignmentTrack>
                        </AssignmentArea>
                    ) : (
                        <AssignmentArea className='assignSectionInr assignSectionData'>
                        {map(dueToday, d =>
                            currentUser.role === "teacher"
                            ? renderTeacherAssignment(d)
                            : renderStudentAssignment(d)
                        )}
                        </AssignmentArea>
                    )}
                  </Section>
                </div>

                {/* <Section className="rghtAssignSec">
                    <SectionHeader>upcoming this week</SectionHeader>
                    <AssignmentArea className="assignDate">
                        {upcommingThisWeek.length === 0 || upComingcheckOnDisable ? <AssignmentTrack className="assigntrack">
                            <TrackLabel>No assignments at this moment.</TrackLabel>
                            <TrackIcon src={robert2} title="" alt="" />
                        </AssignmentTrack> : map(upcommingThisWeek, d => (currentUser.role == "teacher" ? renderTeacherAssignment(d) : renderStudentAssignment(d)))}
                    </AssignmentArea>
                </Section> */}

                <div className='assignSection'>
                  <SectionHeader className='misWeekLabel'>Missing this week</SectionHeader>
                  <Section>
                    {(pastDueThisWeek.length === 0 || pastCheckOnDisable) ? (
                        <AssignmentArea className='assignSectionInr'>
                        <AssignmentTrack className='assignSectionInrSub'>
                            <TrackLabel className='assignSectionInrSubLeft'>
                            You are on track!
                            </TrackLabel>
                            <img
                            src={missingSvg}
                            alt=""
                            title=""
                            />
                        </AssignmentTrack>
                        </AssignmentArea>
                    ) : (
                        <AssignmentArea className='assignSectionInr assignSectionData'>
                        {map(pastDueThisWeek, d =>
                            currentUser.role === "teacher"
                            ? renderTeacherAssignment(d)
                            : renderStudentAssignment(d)
                        )}
                        </AssignmentArea>
                    )}
                    </Section>

                </div>
            </Wrapper>
         </div>
        </SentryWrap>
    )
}
